"use client";

import { useFormContext } from 'react-hook-form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Label } from '@/components/ui/label';

interface RadioOption {
  value: string | boolean;
  label: string;
}

interface RadioGroupFieldProps {
  name: string;
  label: string;
  options: ReadonlyArray<RadioOption>;
  required?: boolean;
  disabled?: boolean;
  onValueChange?: (value: string | boolean | undefined) => void;
}

export function RadioGroupField({ 
  name, 
  label, 
  options,
  required = false,
  disabled = false,
  onValueChange,
}: RadioGroupFieldProps) {
  const { control, setValue } = useFormContext();
  
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="space-y-3">
          <FormLabel>{label} {required && '*'}</FormLabel>
          <FormControl>
            <RadioGroup
              onValueChange={(value) => {
                if (value === undefined || value === null || value === '') {
                  onValueChange?.(undefined);
                  field.onChange(undefined);
                  setValue(`${name}_label`, undefined);
                } else {
                  const convertedValue = value === 'true' ? true : value === 'false' ? false : value;
                  onValueChange?.(convertedValue);
                  field.onChange(convertedValue);
                  
                  const selectedOption = options.find(option => option.value?.toString() === value);
                  if (selectedOption) {
                    setValue(`${name}_label`, selectedOption.label);
                  }
                }
              }}
              value={field.value !== undefined && field.value !== null ? field.value.toString() : ""}
              disabled={disabled}
              className="flex flex-col space-y-2"
            >
              {options.map((option) => (
                <div key={option.value?.toString()} className="flex items-center space-x-2">
                  <RadioGroupItem value={option.value?.toString()} id={`${name}-${option.value?.toString()}`} />
                  <Label htmlFor={`${name}-${option.value?.toString()}`}>{option.label}</Label>
                </div>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
